/**
 * 计费模板 | 分账模板 | 卡片模板
 */
import Net from '../net';

const NAME = '[OperatorModelApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === ChargeModel === **/
/** charge-config/list
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.mode_type
*/
export async function getChargeModelList(data = {}) {
  Log('getChargeModelList data:', data)
  try {
    const res = await Net.http('charge-config/list', { data })
    Log('getChargeModelList res:', res)
    return res
  } catch (err) {
    Log('getChargeModelList err:', err)
    throw err
  }
}

/** charge_config/list
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.mode_type
*/
export async function getChargeModelListByOperator(data = {}) {
  Log('getChargeModelListByOperator data:', data)
  try {
    const res = await Net.http('charge_config/list', { data })
    Log('getChargeModelListByOperator res:', res)
    return res
  } catch (err) {
    Log('getChargeModelListByOperator err:', err)
    throw err
  }
}

/** charge-config/detail
 * @param {Object} data
 * @param {*} data.charge_config_id
*/
export async function getChargeModelDetail(data = {}) {
  Log('getChargeModelDetail data:', data)
  try {
    const res = await Net.http('charge-config/detail', { data })
    Log('getChargeModelDetail res:', res)
    return res
  } catch (err) {
    Log('getChargeModelDetail err:', err)
    throw err
  }
}

/** charge_config/detail
 * @param {Object} data
 * @param {*} data.charge_config_id
*/
export async function getChargeModelDetailByOperator(data = {}) {
  Log('getChargeModelDetailByOperator data:', data)
  try {
    const res = await Net.http('charge_config/detail', { data })
    Log('getChargeModelDetailByOperator res:', res)
    return res
  } catch (err) {
    Log('getChargeModelDetailByOperator err:', err)
    throw err
  }
}

/** charge-config/delete
 * @param {Object} data
 * @param {*} data.charge_config_id
*/
export async function deleteChargeModel(data = {}) {
  Log('deleteChargeModel data:', data)
  try {
    const res = await Net.http('charge-config/delete', { data })
    Log('deleteChargeModel res:', res)
    return res
  } catch (err) {
    Log('deleteChargeModel err:', err)
    throw err
  }
}

/** charge_config/delete
 * @param {Object} data
 * @param {*} data.charge_config_id
*/
export async function deleteChargeModelByOperator(data = {}) {
  Log('deleteChargeModelByOperator data:', data)
  try {
    const res = await Net.http('charge_config/delete', { data })
    Log('deleteChargeModelByOperator res:', res)
    return res
  } catch (err) {
    Log('deleteChargeModelByOperator err:', err)
    throw err
  }
}

/** charge-config/save
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.charge_config_id
 * @param {*} data.sp
 * @param {*} data.name
 * @param {*} data.mode
 * @param {*} data.list
 * @param {*} data.flag_show_charge_detail
 * @param {*} data.unit_name
 * @param {*} data.min_money
 * @param {*} data.custom_money
 * @param {*} data.service_fee_mode
 * @param {*} data.service_charge_min
 * @param {*} data.service_charge_max
 * @param {*} data.occupy_list
 * @param {*} data.occupy_free_minute
 * @param {*} data.deposit
 * @param {*} data.exchange_mode
 * @param {*} data.min_consume_money
 * @param {*} data.flag_gate_enable
 * @param {*} data.charge_pre_occupy_fee_config
 * @param {*} data.charge_finish_occupy_fee_config
*/
export async function createChargeModel(data = {}) {
  Log('createChargeModel data:', data)
  try {
    const res = await Net.http('charge-config/save', { data })
    Log('createChargeModel res:', res)
    return res
  } catch (err) {
    Log('createChargeModel err:', err)
    throw err
  }
}

/** charge_config/save
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.charge_config_id
 * @param {*} data.sp
 * @param {*} data.name
 * @param {*} data.mode
 * @param {*} data.list
 * @param {*} data.flag_show_charge_detail
 * @param {*} data.unit_name
 * @param {*} data.min_money
 * @param {*} data.custom_money
 * @param {*} data.service_fee_mode
 * @param {*} data.service_charge_min
 * @param {*} data.service_charge_max
 * @param {*} data.occupy_list
 * @param {*} data.occupy_free_minute
 * @param {*} data.deposit
 * @param {*} data.exchange_mode
 * @param {*} data.min_consume_money
 * @param {*} data.flag_gate_enable
 * @param {*} data.charge_pre_occupy_fee_config
 * @param {*} data.charge_finish_occupy_fee_config
*/
export async function createChargeModelByOperator(data = {}) {
  Log('createChargeModelByOperator data:', data)
  try {
    const res = await Net.http('charge_config/save', { data })
    Log('createChargeModelByOperator res:', res)
    return res
  } catch (err) {
    Log('createChargeModelByOperator err:', err)
    throw err
  }
}

/** org/list-by-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.org_name
*/
export async function getChargeModelListByOrg(data = {}) {
  Log('getChargeModelListByOrg data:', data)
  try {
    const res = await Net.http('org/list-by-charge-config', { data })
    Log('getChargeModelListByOrg res:', res)
    return res
  } catch (err) {
    Log('getChargeModelListByOrg err:', err)
    throw err
  }
}

/** station/list-by-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.station_name
*/
export async function getChargeModelListByStation(data = {}) {
  Log('getChargeModelListByStation data:', data)
  try {
    const res = await Net.http('station/list-by-charge-config', { data })
    Log('getChargeModelListByStation res:', res)
    return res
  } catch (err) {
    Log('getChargeModelListByStation err:', err)
    throw err
  }
}

/** station/list-by-occupy-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.station_name
*/
export async function chargeModelOccupyListByStation(data = {}) {
  Log('chargeModelOccupyListByStation data:', data)
  try {
    const res = await Net.http('station/list-by-occupy-charge-config', { data })
    Log('chargeModelOccupyListByStation res:', res)
    return res
  } catch (err) {
    Log('chargeModelOccupyListByStation err:', err)
    throw err
  }
}

/** org/list-by-occupy-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.org_name
*/
export async function chargeModelOccupyListByOrg(data = {}) {
  Log('chargeModelOccupyListByOrg data:', data)
  try {
    const res = await Net.http('org/list-by-occupy-charge-config', { data })
    Log('chargeModelOccupyListByOrg res:', res)
    return res
  } catch (err) {
    Log('chargeModelOccupyListByOrg err:', err)
    throw err
  }
}


/** === SettlementModel === **/
/** clearing-config/save
 * @param {Object} data
 * @param {*} data.json
 * @param {*} data.service_fee_account_id
*/
export async function saveSettlementModel(data = {}) {
  Log('saveSettlementModel data:', data)
  try {
    const res = await Net.http('clearing-config/save', { data })
    Log('saveSettlementModel res:', res)
    return res
  } catch (err) {
    Log('saveSettlementModel err:', err)
    throw err
  }
}

/** clearing-config/detail
 * @param {Object} data
 * @param {*} data.clearing_config_id
*/
export async function getSettlementModelDetail(data = {}) {
  Log('getSettlementModelDetail data:', data)
  try {
    const res = await Net.http('clearing-config/detail', { data })
    Log('getSettlementModelDetail res:', res)
    return res
  } catch (err) {
    Log('getSettlementModelDetail err:', err)
    throw err
  }
}

/** clearing-config/delete
 * @param {Object} data
 * @param {*} data.clearing_config_id
*/
export async function deleteSettlementModel(data = {}) {
  Log('deleteSettlementModel data:', data)
  try {
    const res = await Net.http('clearing-config/delete', { data })
    Log('deleteSettlementModel res:', res)
    return res
  } catch (err) {
    Log('deleteSettlementModel err:', err)
    throw err
  }
}

/** clearing-config/list
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getSettlementModelList(data = {}) {
  Log('getSettlementModelList data:', data)
  try {
    const res = await Net.http('clearing-config/list', { data })
    Log('getSettlementModelList res:', res)
    return res
  } catch (err) {
    Log('getSettlementModelList err:', err)
    throw err
  }
}

/** clearing-config/list
 * @param {Object} data
 * @param {*} data.station_operator_id
*/
export async function getSettlementModelListByOperator(data = {}) {
  Log('getSettlementModelListByOperator data:', data)
  try {
    const res = await Net.http('clearing-config/list', { data })
    Log('getSettlementModelListByOperator res:', res)
    return res
  } catch (err) {
    Log('getSettlementModelListByOperator err:', err)
    throw err
  }
}

/** org/list-by-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_config_id
 * @param {*} data.org_name
*/
export async function settlementModelChargeListByOrg(data = {}) {
  Log('settlementModelChargeListByOrg data:', data)
  try {
    const res = await Net.http('org/list-by-clearing-config', { data })
    Log('settlementModelChargeListByOrg res:', res)
    return res
  } catch (err) {
    Log('settlementModelChargeListByOrg err:', err)
    throw err
  }
}

/** org/list-by-recharge-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.recharge-clearing_config_id
 * @param {*} data.org_name
*/
export async function settlementModelRechargeListByOrg(data = {}) {
  Log('settlementModelRechargeListByOrg data:', data)
  try {
    const res = await Net.http('org/list-by-recharge-clearing-config', { data })
    Log('settlementModelRechargeListByOrg res:', res)
    return res
  } catch (err) {
    Log('settlementModelRechargeListByOrg err:', err)
    throw err
  }
}

/** station/list-by-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_config_id
 * @param {*} data.station_name
*/
export async function settlementModelChargeListByStation(data = {}) {
  Log('settlementModelChargeListByStation data:', data)
  try {
    const res = await Net.http('station/list-by-clearing-config', { data })
    Log('settlementModelChargeListByStation res:', res)
    return res
  } catch (err) {
    Log('settlementModelChargeListByStation err:', err)
    throw err
  }
}

/** clearing-config/list-by-energy-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_config_id
 * @param {*} data.name
 * @param {*} data.target_type
*/
export async function settlementModelChargeFeeList(data = {}) {
  Log('settlementModelChargeFeeList data:', data)
  try {
    const res = await Net.http('clearing-config/list-by-energy-clearing-config', { data })
    Log('settlementModelChargeFeeList res:', res)
    return res
  } catch (err) {
    Log('settlementModelChargeFeeList err:', err)
    throw err
  }
}

/** station/list-bind-by-energy-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_config_id
 * @param {*} data.name
*/
export async function settlementModelEnergyListByStation(data = {}) {
  Log('settlementModelEnergyListByStation data:', data)
  try {
    const res = await Net.http('station/list-bind-by-energy-clearing-config', { data })
    Log('settlementModelEnergyListByStation res:', res)
    return res
  } catch (err) {
    Log('settlementModelEnergyListByStation err:', err)
    throw err
  }
}

/** org/list-bind-by-energy-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.clearing_config_id
 * @param {*} data.name
*/
export async function settlementModelEnergyListByOrg(data = {}) {
  Log('settlementModelEnergyListByOrg data:', data)
  try {
    const res = await Net.http('org/list-bind-by-energy-clearing-config', { data })
    Log('settlementModelEnergyListByOrg res:', res)
    return res
  } catch (err) {
    Log('settlementModelEnergyListByOrg err:', err)
    throw err
  }
}


/** === CardModel === **/
/** resource-package-config/list-by-operator-id
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.type
*/
export async function getCardModelList(data = {}) {
  Log('getCardModelList data:', data)
  try {
    const res = await Net.http('resource-package-config/list-by-operator-id', { data })
    Log('getCardModelList res:', res)
    return res
  } catch (err) {
    Log('getCardModelList err:', err)
    throw err
  }
}

/** resource-package-config/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.resource_json
*/
export async function saveCardModel(data = {}) {
  Log('saveCardModel data:', data)
  try {
    const res = await Net.http('resource-package-config/save', { data })
    Log('saveCardModel res:', res)
    return res
  } catch (err) {
    Log('saveCardModel err:', err)
    throw err
  }
}

/** resource-package-config/delete
 * @param {Object} data
 * @param {*} data.resource_package_config_id
 * @param {*} data.flag_force
*/
export async function deleteCardModel(data = {}) {
  Log('deleteCardModel data:', data)
  try {
    const res = await Net.http('resource-package-config/delete', { data })
    Log('deleteCardModel res:', res)
    return res
  } catch (err) {
    Log('deleteCardModel err:', err)
    throw err
  }
}

/** resource-package-config/detail
 * @param {Object} data
 * @param {*} data.resource_package_config_id
*/
export async function getCardModelDetail(data = {}) {
  Log('getCardModelDetail data:', data)
  try {
    const res = await Net.http('resource-package-config/detail', { data })
    Log('getCardModelDetail res:', res)
    return res
  } catch (err) {
    Log('getCardModelDetail err:', err)
    throw err
  }
}

/** resource-package-config/detail-by-org-id
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getCardModelDetailByOrgId(data = {}) {
  Log('getCardModelDetailByOrgId data:', data)
  try {
    const res = await Net.http('resource-package-config/detail-by-org-id', { data })
    Log('getCardModelDetailByOrgId res:', res)
    return res
  } catch (err) {
    Log('getCardModelDetailByOrgId err:', err)
    throw err
  }
}

/** org/list-by-recharge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.recharge_config_id
 * @param {*} data.recharge_car_config_id
 * @param {*} data.org_name
*/
export async function getCardModelListByOrg(data = {}) {
  Log('getCardModelListByOrg data:', data)
  try {
    const res = await Net.http('org/list-by-recharge-config', { data })
    Log('getCardModelListByOrg res:', res)
    return res
  } catch (err) {
    Log('getCardModelListByOrg err:', err)
    throw err
  }
}
